var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "standard-product-form uk-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.basicFields')))]), _vm._v(" "), _c('readonly-form-field', {
    attrs: {
      "errors": _vm.fields.errors.name,
      "label": _vm.$t('fields.name')
    }
  }, [_c('text-placeholder', {
    attrs: {
      "text": _vm.name
    }
  })], 1), _vm._v(" "), _c('product-family-combobox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.family,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.family')
    },
    model: {
      value: (_vm.fields.values.family),
      callback: function($$v) {
        _vm.fields.values.family = $$v
      },
      expression: "fields.values.family"
    }
  }), _vm._v(" "), _c('text-input', {
    ref: "variantNameField",
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.variantName,
      "label": _vm.$t('fields.variantName'),
      "placeholder": _vm.$t('placeholders.variantName'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.variantName),
      callback: function($$v) {
        _vm.fields.values.variantName = $$v
      },
      expression: "fields.values.variantName"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.articleNumber,
      "label": _vm.$t('fields.articleNumber'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.articleNumber),
      callback: function($$v) {
        _vm.fields.values.articleNumber = $$v
      },
      expression: "fields.values.articleNumber"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.ean,
      "label": _vm.$t('fields.ean'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.ean),
      callback: function($$v) {
        _vm.fields.values.ean = $$v
      },
      expression: "fields.values.ean"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "type": "text",
      "label": _vm.$t('fields.manufacturerProductCode'),
      "errors": _vm.fields.errors.manufacturerProductCode,
      "placeholder": _vm.$t('placeholders.manufacturerProductCode'),
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.manufacturerProductCode),
      callback: function($$v) {
        _vm.fields.values.manufacturerProductCode = $$v
      },
      expression: "fields.values.manufacturerProductCode"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.tags,
      "label": _vm.$t('fields.tags')
    },
    model: {
      value: (_vm.fields.values.tags),
      callback: function($$v) {
        _vm.fields.values.tags = $$v
      },
      expression: "fields.values.tags"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.selectors')))]), _vm._v(" "), _c('color-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.color,
      "label": _vm.$t('fields.color')
    },
    model: {
      value: (_vm.fields.values.color),
      callback: function($$v) {
        _vm.fields.values.color = $$v
      },
      expression: "fields.values.color"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.size,
      "label": _vm.$t('fields.size'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.size),
      callback: function($$v) {
        _vm.fields.values.size = $$v
      },
      expression: "fields.values.size"
    }
  }), _vm._v(" "), _c('memory-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.memory,
      "label": _vm.$t('fields.memory')
    },
    model: {
      value: (_vm.fields.values.memory),
      callback: function($$v) {
        _vm.fields.values.memory = $$v
      },
      expression: "fields.values.memory"
    }
  }), _vm._v(" "), _c('memory-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.storage,
      "label": _vm.$t('fields.storage')
    },
    model: {
      value: (_vm.fields.values.storage),
      callback: function($$v) {
        _vm.fields.values.storage = $$v
      },
      expression: "fields.values.storage"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.details')))]), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.securityInformationUrl,
      "label": _vm.$t('fields.securityInformationUrl'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.securityInformationUrl),
      callback: function($$v) {
        _vm.fields.values.securityInformationUrl = _vm._n($$v)
      },
      expression: "fields.values.securityInformationUrl"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.altName,
      "label": _vm.$t('fields.altName'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.altName),
      callback: function($$v) {
        _vm.fields.values.altName = $$v
      },
      expression: "fields.values.altName"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.deliveredItems,
      "label": _vm.$t('fields.deliveredItems')
    },
    model: {
      value: (_vm.fields.values.deliveredItems),
      callback: function($$v) {
        _vm.fields.values.deliveredItems = $$v
      },
      expression: "fields.values.deliveredItems"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.shortUsp,
      "label": _vm.$t('fields.shortUsp')
    },
    model: {
      value: (_vm.fields.values.shortUsp),
      callback: function($$v) {
        _vm.fields.values.shortUsp = $$v
      },
      expression: "fields.values.shortUsp"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.usps,
      "label": _vm.$t('fields.usps')
    },
    model: {
      value: (_vm.fields.values.usps),
      callback: function($$v) {
        _vm.fields.values.usps = $$v
      },
      expression: "fields.values.usps"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.summaryTexts,
      "label": _vm.$t('fields.summaryTexts')
    },
    model: {
      value: (_vm.fields.values.summaryTexts),
      callback: function($$v) {
        _vm.fields.values.summaryTexts = $$v
      },
      expression: "fields.values.summaryTexts"
    }
  }), _vm._v(" "), _c('dimensions-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.dimensions,
      "label": _vm.$t('fields.dimensions')
    },
    model: {
      value: (_vm.fields.values.dimensions),
      callback: function($$v) {
        _vm.fields.values.dimensions = $$v
      },
      expression: "fields.values.dimensions"
    }
  }), _vm._v(" "), _c('weight-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.weight,
      "label": _vm.$t('fields.weight')
    },
    model: {
      value: (_vm.fields.values.weight),
      callback: function($$v) {
        _vm.fields.values.weight = $$v
      },
      expression: "fields.values.weight"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.commonCharger')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.possible,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.commonCharger.possible')
    },
    model: {
      value: (_vm.fields.values.commonCharger.possible),
      callback: function($$v) {
        _vm.fields.values.commonCharger.possible = $$v
      },
      expression: "fields.values.commonCharger.possible"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.included,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.commonCharger.included')
    },
    model: {
      value: (_vm.fields.values.commonCharger.included),
      callback: function($$v) {
        _vm.fields.values.commonCharger.included = $$v
      },
      expression: "fields.values.commonCharger.included"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.minWattage,
      "label": _vm.$t('fields.commonCharger.minWattage'),
      "step": "0.5",
      "min": "0.0",
      "type": "number"
    },
    model: {
      value: (_vm.fields.values.commonCharger.minWattage),
      callback: function($$v) {
        _vm.fields.values.commonCharger.minWattage = _vm._n($$v)
      },
      expression: "fields.values.commonCharger.minWattage"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.maxWattage,
      "label": _vm.$t('fields.commonCharger.maxWattage'),
      "step": "0.5",
      "min": "0.0",
      "type": "number"
    },
    model: {
      value: (_vm.fields.values.commonCharger.maxWattage),
      callback: function($$v) {
        _vm.fields.values.commonCharger.maxWattage = _vm._n($$v)
      },
      expression: "fields.values.commonCharger.maxWattage"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.usbPd,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.commonCharger.usbPd')
    },
    model: {
      value: (_vm.fields.values.commonCharger.usbPd),
      callback: function($$v) {
        _vm.fields.values.commonCharger.usbPd = $$v
      },
      expression: "fields.values.commonCharger.usbPd"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.design')))]), _vm._v(" "), _c('product-style-combobox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.style,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.style')
    },
    model: {
      value: (_vm.fields.values.style),
      callback: function($$v) {
        _vm.fields.values.style = $$v
      },
      expression: "fields.values.style"
    }
  }), _vm._v(" "), _c('radio-group-input', {
    attrs: {
      "collection": _vm.productCustomizabilities,
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.customizability,
      "includeBlank": false,
      "label": _vm.$t('fields.customizability')
    },
    model: {
      value: (_vm.fields.values.customizability),
      callback: function($$v) {
        _vm.fields.values.customizability = $$v
      },
      expression: "fields.values.customizability"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.designName,
      "label": _vm.$t('fields.designName'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.designName),
      callback: function($$v) {
        _vm.fields.values.designName = $$v
      },
      expression: "fields.values.designName"
    }
  }), _vm._v(" "), _c('product-design-artist-combobox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.designArtist,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.designArtist')
    },
    model: {
      value: (_vm.fields.values.designArtist),
      callback: function($$v) {
        _vm.fields.values.designArtist = $$v
      },
      expression: "fields.values.designArtist"
    }
  }), _vm._v(" "), _c('product-design-category-combobox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.designCategories,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.designCategories'),
      "multiple": ""
    },
    model: {
      value: (_vm.fields.values.designCategories),
      callback: function($$v) {
        _vm.fields.values.designCategories = $$v
      },
      expression: "fields.values.designCategories"
    }
  }), _vm._v(" "), _c('attachment-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.designImage,
      "label": _vm.$t('fields.designImage'),
      "attachment-type": "IMAGE"
    },
    model: {
      value: (_vm.fields.values.designImage),
      callback: function($$v) {
        _vm.fields.values.designImage = $$v
      },
      expression: "fields.values.designImage"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.features')))]), _vm._v(" "), _c('features-manager', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.features
    },
    model: {
      value: (_vm.fields.values.features),
      callback: function($$v) {
        _vm.fields.values.features = $$v
      },
      expression: "fields.values.features"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.seo')))]), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.slug,
      "label": _vm.$t('fields.slug'),
      "placeholder": _vm.slugPlaceholder,
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.slug),
      callback: function($$v) {
        _vm.fields.values.slug = $$v
      },
      expression: "fields.values.slug"
    }
  }), _vm._v(" "), _c('textarea-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.description,
      "label": _vm.$t('fields.description'),
      "rows": "5"
    },
    model: {
      value: (_vm.fields.values.description),
      callback: function($$v) {
        _vm.fields.values.description = $$v
      },
      expression: "fields.values.description"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.aliases,
      "label": _vm.$t('fields.aliases')
    },
    model: {
      value: (_vm.fields.values.aliases),
      callback: function($$v) {
        _vm.fields.values.aliases = $$v
      },
      expression: "fields.values.aliases"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.keywords,
      "label": _vm.$t('fields.keywords')
    },
    model: {
      value: (_vm.fields.values.keywords),
      callback: function($$v) {
        _vm.fields.values.keywords = $$v
      },
      expression: "fields.values.keywords"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.legalTexts')))]), _vm._v(" "), _c('legal-text-manager', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.legalTexts
    },
    model: {
      value: (_vm.fields.values.legalTexts),
      callback: function($$v) {
        _vm.fields.values.legalTexts = $$v
      },
      expression: "fields.values.legalTexts"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.media')))]), _vm._v(" "), _c('attachment-manager', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.media,
      "attachment-type": "MEDIA_OBJECT"
    },
    model: {
      value: (_vm.fields.values.media),
      callback: function($$v) {
        _vm.fields.values.media = $$v
      },
      expression: "fields.values.media"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": 'Always Displayed?'
    },
    model: {
      value: (_vm.fields.values.alwaysDisplayed),
      callback: function($$v) {
        _vm.fields.values.alwaysDisplayed = $$v
      },
      expression: "fields.values.alwaysDisplayed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-medium-top"
  }, [_c('submit-button', {
    attrs: {
      "disabled": !_vm.isSubmittable,
      "type": "primary"
    }
  }), _vm._v(" "), _c('cancel-button')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c37f4aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/StandardProductForm.vue
// module id = 1977
// module chunks = 0